import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { Button } from "@mui/material";
import useAuth from "../../../../hooks/useAuth";
import { apiVariable } from "../../../../api/apiVariable";
import GenericFormPopup from "../../../Fleet/GenericFormPopup/GenericFormPopup";
import {
  leadFieldConfiguration,
  leadInitialValues,
} from "../../../../formConfigs/FleetCRM/leadFieldConfig";
import StatusSnackbar from "../../../General/StatusSnackbar/StatusSnackbar";

const CreateLeadPopup = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setStatus("idle");

  const queryClient = useQueryClient();
  const { token } = useAuth();

  const leadMutation = useMutation({
    mutationFn: (data: any) =>
      axios.post(`${apiVariable}/lead`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    onSuccess: () => {
      setStatus("success");
      handleClose();
      queryClient.invalidateQueries({ queryKey: ["leads"] });
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response?.data || "Failed to create lead");
    },
  });

  const submitHandler = (data: any) => {
    leadMutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Create Lead
      </Button>
      <GenericFormPopup
        initialValues={leadInitialValues}
        formFields={leadFieldConfiguration}
        title="Create New Lead"
        onSubmit={submitHandler}
        open={open}
        onClose={handleClose}
        loading={leadMutation.isPending}
      />

      <StatusSnackbar
        status={status}
        successMessage="Lead created successfully"
        errorMessage={errorMessage}
        handleClose={handleSnackbarClose}
      />
    </>
  );
};

export default CreateLeadPopup;
